'use strict';

module.exports = [require('./apply.transform'), require('./column.transform'), require('./concat.transform'), require('./filter.transform'), require('./forEach.transform'), require('./index.transform'), require('./map.transform'), require('./max.transform'), require('./mean.transform'), require('./min.transform'), require('./range.transform'), require('./std.transform'), require('./row.transform'), require('./subset.transform'), require('./sum.transform'), require('./var.transform')];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/transform/index.js
// module id = 1003
// module chunks = 0